// extracted by mini-css-extract-plugin
export default {"wrapper":"ItemInfo_wrapper__rFACC","title":"ItemInfo_title__4Z8q4","value":"ItemInfo_value__DjtWL"};